export { default as Rates } from './container';
